import { ENav } from "components/Layout/types";
import { MAP_SIDEBAR_NAV } from "components/Layout/constants";

export const getCurrentActiveSidebarNav = (pathname: string) => {
  const splitedPaths = pathname.split("/");
  if (splitedPaths?.length >= 3) {
    return MAP_SIDEBAR_NAV?.[splitedPaths[2]] || ENav.DASHBOARD;
  }

  return ENav.DASHBOARD;
};
